module.exports = __webpack_public_path__ + "img/notice@2x-100.61a7c09f.jpg";